import {StyleSheet} from 'react-native';

// This file contains commonly used styles over all files and it will helps us to remove duplicate styles.
// Deliberately color-free since the dark-mode migration (#67): shared styles
// here are structural only — anything color-bearing lives in each screen's
// themed makeStyles factory.

const CommonStyles = StyleSheet.create({
  full_flex: {
    flex: 1,
  },
  full_grow: {
    flexGrow: 1,
  },
  flex_row: {
    flexDirection: 'row',
  },
  items_center: {
    alignItems: 'center',
  },
  flex_center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  justify_center: {
    justifyContent: 'center',
  },
  justify_start: {
    justifyContent: 'start',
  },
  self_start: {
    alignSelf: 'flex-start',
  },
  self_center: {
    alignSelf: 'center',
  },
  self_end: {
    alignSelf: 'flex-end',
  },
  flex_display: {
    display: 'flex',
  },
  full_screen_height: {
    height: '100vh',
  },
  full_height: {
    height: '100%',
  },
  half_height: {
    height: '50%',
  },
  full_width: {
    width: '100%',
  },
  half_width: {
    width: '50%',
  },
  half_min_width: {
    minWidth: '50%',
  },
  text_center: {
    textAlign: 'center',
  },
  font_18: {
    fontSize: 18,
  },
  mt_4: {
    marginTop: 4,
  },
  mb_4: {
    marginBottom: 4,
  },
  mh_8: {
    marginHorizontal: 8,
  },
  mt_8: {
    marginTop: 8,
  },
  mb_8: {
    marginBottom: 8,
  },
  ml_8: {
    marginLeft: 8,
  },
  mr_8: {
    marginRight: 8,
  },
  mt_10: {
    marginTop: 10,
  },
  ml_10: {
    marginLeft: 10,
  },
  mr_10: {
    marginRight: 10,
  },
  mh_12: {
    marginHorizontal: 12,
  },
  mt_12: {
    marginTop: 12,
  },
  mb_12: {
    marginBottom: 12,
  },
  ml_12: {
    marginLeft: 12,
  },
  mr_12: {
    marginRight: 12,
  },
  mh_16: {
    marginHorizontal: 16,
  },
  mt_16: {
    marginTop: 16,
  },
  mb_16: {
    marginBottom: 16,
  },
  ml_16: {
    marginLeft: 16,
  },
  mr_16: {
    marginRight: 16,
  },
  mr_20: {
    marginRight: 20,
  },
  mt_22: {
    marginTop: 22,
  },
  mb_22: {
    marginBottom: 22,
  },
  m_24: {
    margin: 24,
  },
  mv_24: {
    marginVertical: 24,
  },
  mh_24: {
    marginHorizontal: 24,
  },
  mt_24: {
    marginTop: 24,
  },
  mb_24: {
    marginBottom: 24,
  },
  mr_24: {
    marginRight: 24,
  },
  m_32: {
    margin: 32,
  },
  mv_32: {
    marginVertical: 32,
  },
  mh_32: {
    marginHorizontal: 32,
  },
  mt_32: {
    marginTop: 32,
  },
  mb_32: {
    marginBottom: 32,
  },
  ml_32: {
    marginLeft: 32,
  },
  mr_32: {
    marginRight: 32,
  },
  mv_40: {
    marginVertical: 40,
  },
  mt_42: {
    marginTop: 42,
  },
  mb_42: {
    marginBottom: 42,
  },
  mv_48: {
    marginVertical: 48,
  },
  mt_48: {
    marginTop: 48,
  },
  mb_52: {
    marginBottom: 52,
  },
  p_8: {
    padding: 8,
  },
  ph_8: {
    paddingHorizontal: 8,
  },
  pv_10: {
    paddingVertical: 10,
  },
  p_16: {
    padding: 16,
  },
  ph_16: {
    paddingHorizontal: 16,
  },
  pb_16: {
    paddingBottom: 16,
  },
  p_24: {
    padding: 24,
  },
  pv_24: {
    paddingVertical: 24,
  },
  ph_24: {
    paddingHorizontal: 24,
  },
  pt_24: {
    paddingTop: 24,
  },
  pb_24: {
    paddingBottom: 24,
  },
  p_32: {
    padding: 32,
  },
  pv_32: {
    paddingVertical: 32,
  },
  ph_32: {
    paddingHorizontal: 32,
  },
  pb_36: {
    paddingBottom: 36,
  },
  pv_48: {
    paddingVertical: 48,
  },
  ph_56: {
    paddingHorizontal: 56,
  },
  pt_56: {
    paddingTop: 56,
  },
  pb_56: {
    paddingBottom: 56,
  },
  pl_56: {
    paddingLeft: 56,
  },
  pr_56: {
    paddingRight: 56,
  },
  br_16: {
    borderRadius: 16,
  },
  br_8: {
    borderRadius: 8,
  },
  max_width_292: {
    maxWidth: 292,
  },
  max_width_327: {
    maxWidth: 327,
  },
  underlined_text: {
    textDecorationLine: 'underline',
  },
  absolute_pos: {
    position: 'absolute',
  },
  t_0: {
    top: 0,
  },
  b_0: {
    bottom: 0,
  },
  l_0: {
    left: 0,
  },
  r_0: {
    right: 0,
  },
  oulinewidth_0: {
    outlineWidth: 0,
  },
  bw_0: {
    borderWidth: 0,
  },
  bw_1: {
    borderWidth: 1,
  },
  full_overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
});

export default CommonStyles;
